export default "__VITE_ASSET__A4qPJ3W1__"